<!-- 图书柜-我要买书-我的预定 -->
<template>
  <div class="BookcaseMyReserve">
    <div class="list-wrapper" v-if="list.length !== 0">
      <div class="list" v-for="(item, index) in list" :key="index" @click.self="goGoodsDetail(item)">
        <img class="cover" :src="item.image" alt="">
        <div class="detail">
          <p class="bTit">{{item.name}}</p>
          <p class="intro">简介：{{item.intro}}</p>
          <p :class="['time', {'due': item.isdue}]">
            剩余时间：
            <!-- <span class="color">{{item.appoint_time}}</span> -->
            <TimeCountDown class="color" timeReset :time="item.appoint_time" :index="index" @reset="watchTimeEnd" @timeFull="watchTimeFull"></TimeCountDown>
          </p>
        </div>
        <p class="price">￥{{item.price}}</p>
        <div class="bbtnArea">
          <p class="bbtn bbtn-default mini" @click="goGoodsDetail(item)">详情</p>
          <p class="bbtn bbtn-p mini" @click="goOpenBox(item)">开箱</p>
        </div>
      </div>
    </div>
    <!-- 无预定商品 -->
    <div class="noReserve" v-else>
      <p class="text">您未预定商品，请点左下角更多，查看其它在库商品</p>
    </div>
    <div class="moreArea" @click="goGoodsList">更多在库商品</div>
  </div>
</template>

<script>
  import TimeCountDown from '@/components/Bookcase/Common/TimeCountDown'
  import { messageError, messageSuccess, showLoading, hideLoading } from '../../../../static/js/utils/utility'
  import { ECMallApi } from '../../../../static/Bookcase/js/api'
  import * as config from '../../../../static/js/config.js'
  let vm

  export default {
    name:'BookcaseMyReserve',
    components: {
      TimeCountDown
    },
    data() {
      return {
        list: []
      }
    },
    created() {
      vm = this
      vm.getUserProduct()
    },
    mounted () {
      // console.log('this', this.$route)
    },
    methods: {
      // 获取我的预定商品
      async getUserProduct () {
        let data = {
          cabinet_id: config.deviceId,
          type: 2
        }

        let res = await ECMallApi.getUserProduct(data)
        if(res.meta.code === 200) {
          vm.list = [...res.data]
        }  else {
          messageError(res.meta.message)
        }
      },
      // 去更多商品列表
      goGoodsList () {
        vm.$router.push('/Bookcase/GoodsList')
      },
      // 去商品详情
      goGoodsDetail (item) {
        vm.$store.state.ECMall_activeGoods = item
          vm.$store.state.ECMall_pageSource = 'MyReserve'
        vm.$router.push('/Bookcase/GoodsDetail')
      },
      // 开箱门，去支付列表
      goOpenBox (item) {
        vm.openBox(item)
      },
      // 开箱（买书开箱取物为3）
      async openBox (item) {
        let data = {
          type: 3,
          cabinet_id: config.deviceId,
          pid: item.pid
        }

        console.log(data)
        showLoading('正在开箱')
        let res = await ECMallApi.openBox(data)
        hideLoading()
        if (res.meta.code === 200) {
          // console.log(res)
          vm.$store.state.ECMall_activeGoods = item
          vm.$store.state.ECMall_pageSource = 'MyReserve'
          vm.$router.push('/Bookcase/BScanCode')
        } else {
          // messageError(res.meta.message)
          messageError('开箱失败,请点击右下方按钮联系客服')
        }
      },

      // 监听倒计时整时事件
      watchTimeFull(e) {
        // console.log(e)
        let index = e.index
        let sval = 3
        if (e.times / sval === 3600) {
          vm.setData({
            ['list[' + index + '].isdue']: true
          })
        }
        // console.log(e.times / sval)
      },
      // 监听倒计时结束事件
      watchTimeEnd(e) {
        // console.log('到时', e)
        let index = e.index
        setTimeout(() => {
          vm.getUserProduct()
        }, 200)
      },
    },
    watch: {
    },
  }
</script>

<style lang="less">
.Bookcase{
  .BookcaseMyReserve {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    .list-wrapper {
      width: 100%;
      height: 100%;
      padding:  0 0.44rem;
      margin: 0.3rem 0;
      overflow-x: hidden;
      overflow-y: scroll;
      .list {
        width: 100%;
        padding: 0.28rem 0.96rem 0.3rem 0.29rem;
        margin-top: 0.3rem;
        background-color: #ffffff;
        border-radius: 0.05rem;
        box-shadow: 0 0.02rem 0.24rem rgba(0, 0, 0, 0.21);
        position: relative;
        display: flex;
        &:first-child {
          margin-top: 0;
        }
        .cover{
          flex-shrink: 0;
          width: 1.5rem;
          height: 2rem;
          margin-right: 0.3rem;
        }
        .detail {
          .bTit {
            margin-top: 0.12rem;
            font-size: 0.34rem;
            line-height: 1;
            font-weight: bold;
          }
          .intro {
            height: 0.64rem;
            margin: 0.22rem 0 0.3rem;
            font-size: 0.24rem;
            line-height: 0.32rem;
            color: #999999;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          .time {
            font-size: 0.28rem;
            color: #666666;
            .color {
              color: #5ca2ff;
            }
            &.due .color{
              color: #f95757;
            }
          }
        }
        .price {
          font-size: 0.34rem;
          line-height: 1;
          font-weight: bold;
          color: #d72f2f;
          position: absolute;
          right: 1.03rem;
          top: 0.43rem;
        }
        .bbtnArea {
          display: flex;
          position: absolute;
          right: 0.4rem;
          bottom: 0.26rem;
          .bbtn {
            width: 1.8rem;
            &+.bbtn {
              margin-left: 0.15rem;
            }
          }
        }
      }
    }
    .moreArea {
      flex-shrink: 0;
      width: 100%;
      height: 1.43rem;
      line-height: 1.43rem;
      font-size: 0.36rem;
      font-weight: bold;
      text-indent: 1.23rem;
      box-shadow: 0 0.02rem 0.24rem rgba(0, 0, 0, 0.21);
      background: url(/static/Bookcase/images/icon_book.png) 0.43rem center no-repeat #ffffff;
      // position: absolute;
      // bottom: 0;
      // left: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Bookcase/Buy/MyReserve.vue